import { render, staticRenderFns } from "./PortfolioCreatorCalculator.vue?vue&type=template&id=38a296aa&scoped=true&"
import script from "./PortfolioCreatorCalculator.vue?vue&type=script&lang=js&"
export * from "./PortfolioCreatorCalculator.vue?vue&type=script&lang=js&"
import style0 from "./PortfolioCreatorCalculator.vue?vue&type=style&index=0&id=38a296aa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a296aa",
  null
  
)

export default component.exports